<template>
  <footer>
    <div class="container">
      <div class="left-section">
        <LogoNav width="209" height="50" />
        <p class="mt-6" style="font-size: 18px; font-weight: bold; font-family: 'Poppins';">
          PT Generasi Anak Muda Berkarya<br>
        </p>

        <div class="contact-item" style="align-items: flex-start;" @click="toAction('maps')">
          <LocationIcon />
          <div>
            <p style="font-family: 'Poppins'; font-weight: 300; margin: 0; font-size: 14px;">Kantorkuu Coworking & Office
              Space Agro Plaza Kuningan,<br />Jl. H.R Rasuna Said, RT 7/ RW 4, Kuningan Timur, Setia Budi, Jakarta 12950
            </p>
          </div>
        </div>
        <div class="contact-details mt-6">
          <div class="contact-item" @click="toAction('wa')">
            <PhoneIcon />
            <span style="font-size: 14px;">(+62) 821 2727 4632</span>
          </div>
          <div class="contact-item ml-5" @click="toAction('mail')">
            <MailIcon />
            <span style="font-size: 14px;">hello@hicolleagues.com</span>
          </div>
        </div>
        <div class="social-media-icons mt-10">
          <div v-for="(sosmed, index) in socialMedia" :key="index" class="child" @click="toSosmed(sosmed.link)"
            style="cursor: pointer">
            <component :is="sosmed.img"></component>
          </div>
        </div>
      </div>

      <div class="right-section">
        <div class="links-grid-deks">
          <div class="link-column">
            <h4>Bootcamp</h4>
            <div v-for="(link, index) in linkProducts" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
            <h4>Certification</h4>
            <div v-for="(i, certification) in linkCertification" :key="certification.id">
              <span @click="navigateTo(i.url)">{{ i.name }}</span>
            </div>
          </div>
          <div class="link-column">
            <h4>For Corporate</h4>
            <div v-for="(link, index) in linkInformations" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
            <h4>Others</h4>
            <div v-for="(link, index) in linkOther" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
          </div>
          <div class="link-column">
            <h4>HiColleagues</h4>
            <div v-for="(link, index) in linkEtcs" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
          </div>
        </div>
        <div class="links-grid-mob">
          <div class="link-column">
            <h4>Bootcamp</h4>
            <div v-for="(link, index) in linkProducts" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
            <h4>For Corporate</h4>
            <div v-for="(link, index) in linkInformations" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
            <h4>Others</h4>
            <div v-for="(link, index) in linkOther" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
          </div>
          <div class="link-column">
            <h4>Certification</h4>
            <div v-for="(link, index) in linkCertification" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
            <h4>HiColleagues</h4>
            <div v-for="(link, index) in linkEtcs" :key="index.id">
              <span @click="navigateTo(link.url)">{{ link.name }}</span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <hr class="mt-4" />
    <p class="copyright">Copyright © {{ new Date().getFullYear() }} - PT Generasi Anak Muda Berkarya</p>
  </footer>
</template>

<script>
import LogoNav from '../assets/icons/LogoNav.vue';
import PhoneIcon from '@/assets/icons/PhoneFooter.vue';
import MailIcon from '@/assets/icons/MailFooter.vue';
import LocationIcon from '@/assets/icons/LocationFooter.vue';
import Instagram from '@/assets/icons/sosmed/Instagram.vue';
import Facebook from '@/assets/icons/sosmed/Facebook.vue';
import Linkedin from '@/assets/icons/sosmed/Linkedin.vue';
import Tiktok from '@/assets/icons/sosmed/Tiktok.vue';
import Youtube from '@/assets/icons/sosmed/Youtube.vue';

export default {
  name: "Footer",
  components: {
    LogoNav,
    PhoneIcon,
    LocationIcon,
    MailIcon,
    Instagram,
    Facebook,
    Linkedin,
    Tiktok,
    Youtube
  },
  data() {
    return {
      socialMedia: [
        {
          id: 1,
          name: "instagram",
          img: Instagram,
          link: "https://instagram.com/hicolleagues"
        },
        {
          id: 2,
          name: "facebook",
          img: Facebook,
          link: "https://www.facebook.com/hicolleagues/"
        },
        {
          id: 3,
          name: "linkedin",
          img: Linkedin,
          link: "https://www.linkedin.com/company/hicolleagues?originalSubdomain=id"
        },
        {
          id: 4,
          name: "tiktok",
          img: Tiktok,
          link: "https://www.tiktok.com/@hicolleagues"
        },
        {
          id: 5,
          name: "youtube",
          img: Youtube,
          link: "https://www.youtube.com/@HiColleagues"
        },
      ],
      linkProducts: [
        {
          id: 1,
          name: "Fullstack Web Development with AI Integration",
          url: "/class/bootcamp/fullstack-web-development-with-integration-ai",
        },
      ],
      linkCertification: [
        {
          id: 1,
          name: "Certified Big Data by Alicloud",
          url: "/certification/detail/pelatihan-dan-sertifikasi-big-data-alibaba-cloud",
        },
        {
          id: 2,
          name: "Certified Cloud Computing by Alicloud",
          url: "/certification/detail/alibaba-cloud-computing-certification",
        },
        {
          id: 3,
          name: "Certified Junior Coder by BNSP",
          url: "/certification/detail/junior-coder",
        },
        {
          id: 4,
          name: "Certified Junior Web Developer by BNSP",
          url: "/certification/detail/junior-web-programmer",
        },
      ],
      linkInformations: [
        {
          id: 1,
          name: "Corporate Training",
          url: "/corporate/training",
        },
        {
          id: 2,
          name: "Collaboration Partner",
          url: "/corporate/collaboration",
        },
        {
          id: 3,
          name: "Talent as a Service",
          url: "/corporate/talent-service",
        },
        {
          id: 4,
          name: "Technology Service",
          url: "/corporate/services",
        },
      ],
      linkEtcs: [
        {
          id: 1,
          name: "Tentang Kami",
          url: "/about",
        },
        {
          id: 2,
          name: "Portfolio",
          url: "/portfolio",
        },
        {
          id: 3,
          name: "Testimoni",
          url: "/testimony",
        },
        {
          id: 4,
          name: "FAQ",
          url: "/faq",
        },
        {
          id: 5,
          name: "Hubungi Kami",
          url: "/contact-us",
        },
        {
          id: 6,
          name: "Kebijakan Privasi",
          url: "/privacy-policy",
        },
        {
          id: 7,
          name: "Syarat & Ketentuan",
          url: "/term-condition",
        },
      ],
      linkOther: [
        {
          id: 1,
          name: "Digital Insight",
          url: "/digital-insight",
        },
        {
          id: 2,
          name: "Career",
          url: "/career",
        },
      ]
    };
  },
  methods: {
    toSosmed(link) {
      window.open(link, '_blank');
    },
    navigateTo(link) {
      this.$router.push(link);
    },
    toAction(ctx) {
            if (ctx === "mail") {
                window.open("https://mail.google.com/mail/?view=cm&fs=1&to=hello@hicolleagues.com&su=Customer%20Service&body=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya")
              } else if (ctx === "wa") {
                window.open("https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya");
            } else {
                window.open("https://maps.app.goo.gl/tjgh8kwiPcViuAB16")
            }
        },
  }
};
</script>

<style src="./css/footer.css" scoped></style>